import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SalesInsightsAPI from '../../../api/SalesInsightsAPI';

type Props = { timeRange: { start: string; end: string } };

function AverageSalePriceCard({ timeRange }: Props) {
  const { t } = useTranslation();
  const [average, setAverage] = useState<number | null>(null);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await SalesInsightsAPI.getAverageSalePrice({ startTime: timeRange.start, endTime: timeRange.end });
        const data = res.data;
        if (data) {
          setAverage(data.averageSalePrice);
          setCount(data.count ?? 0);
        } else {
          setAverage(0);
          setCount(0);
        }
      } catch {
        setAverage(0);
        setCount(0);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end]);

  const display =
    average !== null
      ? average === 0 && count === 0
        ? '—'
        : average.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : '—';

  return (
    <div className="space-y-1">
      <p className="text-2xl font-bold text-foreground">{display}</p>
      <p className="text-sm text-muted-foreground">{t('stats.avg_sale_price') || 'Avg. sale price'}</p>
    </div>
  );
}

export default AverageSalePriceCard;
